import { ref } from 'vue';

// Module-level singleton so all components share one config fetch
const config = ref(null);

export const useTenantConfig = () => {
    const fetchConfig = async () => {
        try {
            const res = await fetch('/api/tenant-config');
            if (res.ok) {
                config.value = await res.json();
                return;
            }
            console.warn('[TenantConfig] Server returned', res.status);
        } catch (e) {
            console.warn('[TenantConfig] Failed to fetch config:', e.message);
        }

        // Dev fallback: load local theme override when API is unreachable
        if (process.env.NODE_ENV !== 'production') {
            try {
                const local = await import('../config/themeConfig.local.js');
                config.value = { theme: local.default };
                console.info('[TenantConfig] Using themeConfig.local.js as dev fallback');
            } catch {
                // file may not exist — silent
            }
        }
    };

    return { config, fetchConfig };
};
